import { ReactNode } from "react";
import { TooltipContext, TooltipContentModule } from "./tooltip-types";
import { EntityTooltipModule } from "./EntityTooltipModule";
import { ComparisonTooltipModule } from "./ComparisonTooltipModule";
import { MeasureTooltipModule } from "./MeasureTooltipModule";
import { HeaderTooltipModule } from "./HeaderTooltipModule";
import { MeasureHeaderTooltipModule } from "./MeasureHeaderTooltipModule";
import { FormulaHeaderTooltipModule } from "./FormulaHeaderTooltipModule";
import { GroupTooltipModule } from "./GroupTooltipModule";
import { PivotTooltipModule } from "./PivotTooltipModule";
import { ParentGroupTooltipModule } from "./ParentGroupTooltipModule";
import { UserTooltipModule } from "./UserTooltipModule";

const tooltipModules: TooltipContentModule[] = [
  ComparisonTooltipModule,
  EntityTooltipModule,
  FormulaHeaderTooltipModule,
  GroupTooltipModule,
  HeaderTooltipModule,
  MeasureTooltipModule,
  MeasureHeaderTooltipModule,
  ParentGroupTooltipModule,
  PivotTooltipModule,
  UserTooltipModule,
];

export function resolveTooltip(context: TooltipContext): ReactNode {
  const matchingModules = tooltipModules.filter((m) => m.shouldRender(context));
  const tooltipModule = matchingModules.sort(
    (a, b) => b.priority - a.priority
  )[0];

  if (!tooltipModule) {
    return null;
  }
  return tooltipModule.render(context);
}
